import { message } from 'antd';
import { exchangeTokens } from '../services/authAPI';
import * as Auth from '../utils/auth';
import * as adminAPI from '../services/adminAPI';
import * as tenantAPI from '../services/tenantAPI';
import { API_PATH } from '../appConstants';
/**
 * Types
 */
export const START_AUTH = 'start_auth';
export const AUTH_USER = 'auth_user';
export const UNAUTH_USER = 'unauth_user';
export const AUTH_ERROR = 'auth_error';
/* Admin users */
export const REQUEST_ADMIN_USERS = 'request_admin_users';
export const RECEIVE_ADMIN_USERS = 'receive_admin_users';
export const UPDATE_ADMIN_USER = 'update_admin_user';
export const ADD_ADMIN_USER = 'add_admin_user';
export const DELETE_ADMIN_USER = 'delete_admin_user';
/* Tenants */
export const REQUEST_TENANTS = 'request_tenants';
export const RECEIVE_TENANTS = 'receive_tenants';
export const REQUEST_TENANT_BY_ID = 'request_tenant_by_id';
export const RECEIVE_TENANT_BY_ID = 'receive_tenant_by_id';
export const ADD_TENANT = 'add_tenant';
export const UPDATE_TENANT = 'update_tenant';
export const DELETE_TENANT = 'delete_tenant';

/**
 * Action creators
 */

export function login() {
  return (dispatch) => {
    dispatch({
      type: START_AUTH,
    });
    window.location = `${API_PATH}/auth/login`;
  };
}

export function getAccessToken(oneTimeToken) {
  return (dispatch) => {
    exchangeTokens(oneTimeToken)
      .then((tokens) => {
        // - Save JWT token in localstorage
        Auth.setAccessToken(tokens.accessToken);
        Auth.setRefreshToken(tokens.refreshToken);

        const user = {
          name: Auth.getDecodedUserName(),
          uid: Auth.getDecodedUserId(),
        };
        // - Update user state to authenticated
        dispatch({
          type: AUTH_USER,
          payload: user,
        });
      })
      .catch((err) => {
        dispatch({
          type: AUTH_ERROR,
        });
      });
  };
}

export function logout() {
  Auth.removeAllTokens();
  return {
    type: UNAUTH_USER,
  };
}

/* Admin management */
export function getAdminUsers() {
  return (dispatch) => {
    dispatch({
      type: REQUEST_ADMIN_USERS,
    });
    adminAPI.queryAdminUsers()
      .then((users) => {
        dispatch({
          type: RECEIVE_ADMIN_USERS,
          users,
        });
      })
      .catch(() => {
        message.error('Action failed. Please try again.');
      });
  };
}

export function addAdminUser(user) {
  return (dispatch) => {
    adminAPI.createAdminUser(user)
      .then((addedUser) => {
        message.success(`Added user: ${addedUser.email}`);
        dispatch({
          type: ADD_ADMIN_USER,
          user: addedUser,
        });
      })
      .catch(() => {
        message.error('Action failed. Please try again.');
      });
  };
}

export function editAdminUser(adminId, user) {
  return (dispatch) => {
    adminAPI.updateAdminUser(adminId, user)
      .then((editedUser) => {
        message.success(`Updated user: ${editedUser.email}`);
        dispatch({
          type: UPDATE_ADMIN_USER,
          user: editedUser,
        });
      })
      .catch(() => {
        message.error('Action failed. Please try again.');
      });
  };
}

export function deleteAdminUser(adminId) {
  return (dispatch) => {
    adminAPI.deleteAdminUser(adminId)
      .then(() => {
        message.success('User deleted');
        dispatch({
          type: DELETE_ADMIN_USER,
          id: adminId,
        });
      })
      .catch(() => {
        message.error('Action failed. Please try again.');
      });
  };
}

/* Tenant management */
export function getTenants() {
  return (dispatch) => {
    dispatch({
      type: REQUEST_TENANTS,
    });
    tenantAPI.queryTenants()
      .then((tenants) => {
        dispatch({
          type: RECEIVE_TENANTS,
          tenants,
        });
      })
      .catch(() => {
        message.error('Action failed. Please try again.');
      });
  };
}

export function getTenantById(tenantId) {
  return (dispatch) => {
    dispatch({
      type: REQUEST_TENANT_BY_ID,
    });
    tenantAPI.queryTenantById(tenantId)
      .then((tenant) => {
        dispatch({
          type: RECEIVE_TENANT_BY_ID,
          tenant,
        });
      })
      .catch(() => {
        message.error('Action failed. Please try again.');
      });
  };
}

export function addTenant(tenant) {
  return (dispatch) => {
    tenantAPI.createTenant(tenant)
      .then((addedTenant) => {
        message.success(`Added tenant: ${addedTenant.name}`);

        dispatch({
          type: ADD_TENANT,
          tenant: addedTenant,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js